import React, { PropsWithChildren, useState } from 'react';

//utils
import styles from './stages.module.scss';
import SVG from 'react-inlinesvg';

//redux
import { connect } from 'react-redux';
import { LoginState } from '../../../store/login/reducer';
import { RootState } from '../../../store';
import { StoreType, StoreTypesReversed } from '../interfaces/store_types';
import { loginActions } from '../../../store/login/actions';
import { Dispatch } from 'redux';

//tr
import { useTranslation } from 'react-i18next';
import { ShopLoginConnected } from '../components/userInfoComponents/ShopLogin';
import { ShopSignupConnected } from '../components/userInfoComponents/ShopSignup';
import { DisabledBtn } from '../components/userInfoComponents/DisabledButton';

//components

//assets
interface StateProps {
  loginState: LoginState;
  loginInit: () => void;
}
interface UserInfoProps {
  storeType: StoreType;
}
export type userInfoMethods = 'LOGIN' | 'SIGNUP' | 'GUEST';
export const UserInfo: React.FC<
  UserInfoProps & StateProps & PropsWithChildren
> = ({ loginState, loginInit, storeType, children }) => {
  const { t } = useTranslation();
  const [selectedMethod, setSelectedMethod] = useState<
    userInfoMethods | undefined
  >('SIGNUP');
  // Set by the signup "email already exists" CTA.
  const [prefillEmail, setPrefillEmail] = useState<string>('');

  const handleGoToLogin = (email: string) => {
    setPrefillEmail(email);
    setSelectedMethod('LOGIN');
  };

  return (
    <div className={styles.card}>
      <div className={styles.UserInfo}>
        {storeType === StoreTypesReversed.Premium ? (
          <>
            <ShopSignupConnected
              selectedMethod={selectedMethod}
              setSelectedMethod={setSelectedMethod}
              storeType={storeType}
              onGoToLogin={handleGoToLogin}
            />
            <ShopLoginConnected
              selectedMethod={selectedMethod}
              setSelectedMethod={setSelectedMethod}
              showSelect
              initialEmail={prefillEmail}
              storeType={StoreTypesReversed.Premium}
            />
          </>
        ) : (
          <>
            <ShopSignupConnected
              selectedMethod={selectedMethod}
              setSelectedMethod={setSelectedMethod}
              storeType={storeType}
              onGoToLogin={handleGoToLogin}
            />
            <ShopLoginConnected
              selectedMethod={selectedMethod}
              setSelectedMethod={setSelectedMethod}
              showSelect
              initialEmail={prefillEmail}
              storeType={StoreTypesReversed.TipPurchase}
            />
            {!selectedMethod && <DisabledBtn />}
          </>
        )}
        {/* {children} */}
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  loginState: state.login,
});
const mapDispatchToProps = (dispatch: Dispatch) => ({
  loginInit: () => {
    dispatch(loginActions.loginInitAction());
  },
});

export const UserInfoConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(UserInfo);
